module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-6_active-2c4c16e0ec1d760b5177dd525752f4ab.svg";